import { render, staticRenderFns } from "./layout-loading.vue?vue&type=template&id=5d7d2ebc"
import script from "./layout-loading.vue?vue&type=script&lang=js"
export * from "./layout-loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports